import { error } from 'console';
import * as type from '../../types/API/bomDetails';
import { IAction } from '../userMetadataReducer';

const initialState = {
  data: null,
  loading: false,
  error: null,
  itemsBomDetails: {},
  errorData: {}
};

export const getBOMDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BOM_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BOM_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_BOM_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getBOMDetailsByIdReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BOM_DETAILS_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BOM_DETAILS_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_BOM_DETAILS_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getAllBOMDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_ALL_BOM_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_ALL_BOM_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_ALL_BOM_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const createBOMDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.CREATE_BOM_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.CREATE_BOM_DETAILS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.CREATE_BOM_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateBOMDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_BOM_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.UPDATE_BOM_DETAILS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_BOM_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteBOMDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_BOM_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_BOM_DETAILS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_BOM_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteBillOfMaterialsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_BILL_OF_MATERIALS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_BILL_OF_MATERIALS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_BILL_OF_MATERIALS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editBillOfMaterialsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_BILL_OF_MATERIALS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_BILL_OF_MATERIALS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_BILL_OF_MATERIALS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getItemsBomDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_ITEMS_BOM_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_ITEMS_BOM_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        itemsBomDetails: action.payload.responseData.bomItems,
      };
    case type.GET_ITEMS_BOM_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const duplicateBomReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DUPLICATE_BOM:
      return {
        ...state,
        loading: true,
      };
    case type.DUPLICATE_BOM_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.message
      };
    case type.DUPLICATE_BOM_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const bulkUploadBomReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.BULK_UPLOAD_BOM:
      return {
        ...state,
        loading: true,
      };
    case type.BULK_UPLOAD_BOM_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.message,
        errorData: action.payload.responseData?.errorData || []
      };
    case type.BULK_UPLOAD_BOM_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};